
const handler    = require('./users-page-right-handler')


/****************ELEMENTS*****************/
var HTMLwasSelected  = false
var searchFilter     = ''
const allCharts      = {
         userMultipleUser:      { html:'', chart: '',  },
         userMultipleStorage:   { html:'', chart: '',  },
         userMultipleDb:        { html:'', chart: '',  },
}

function HTMLselect(detail){ //console.log('goku init>')
	HTMLwasSelected = true
	allCharts.userMultipleUser.html           = document.getElementById('chartMultipleUser')
	allCharts.userMultipleStorage.html        = document.getElementById('chartMultipleStorage')
	allCharts.userMultipleDb.html             = document.getElementById('chartMultipleDb')

}/*init*/
/****************ELEMENTS*****************/



export function start(detail){  //console.log('TV page Chart >', detail)
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	
	 obj[detail.act].start(detail)
}


const obj = {
      createAllChart:  { start: (detail)=>{  handler.createAllChart(detail,allCharts)	}},
}/**/





